import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  UserLicensesAssignRequestDTO,
  UserLicensesReleaseRequestDTO,
  UserLicensesDeleteRequestDTO,
  UserLicensesReadByTenantIdRequestDTO,
  UserLicensesReadByUserIdRequestDTO,
  UserLicensesSummaryRequestDTO
} from './company-user-licenses.interface';
import {
  UserLicenses_assign,
  UserLicenses_release,
  UserLicenses_delete,
  UserLicenses_readByTenantId,
  UserLicenses_readByUserId,
  UserLicenses_summary
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class UserLicensesService {

  private http = inject(HttpClient);

  UserLicenses_assign(data: UserLicensesAssignRequestDTO): Observable<any> {
    return this.http.post<any>(UserLicenses_assign, data);
  }

  UserLicenses_release(data: UserLicensesReleaseRequestDTO): Observable<any> {
    return this.http.post<any>(UserLicenses_release, data);
  }

  UserLicenses_delete(data: UserLicensesDeleteRequestDTO): Observable<any> {
    return this.http.post<any>(UserLicenses_delete, data);
  }

  UserLicenses_readByTenantId(data: UserLicensesReadByTenantIdRequestDTO): Observable<any> {
    return this.http.post<any>(UserLicenses_readByTenantId, data);
  }

  UserLicenses_readByUserId(data: UserLicensesReadByUserIdRequestDTO): Observable<any> {
    return this.http.post<any>(UserLicenses_readByUserId, data);
  }

  UserLicenses_summary(data: UserLicensesSummaryRequestDTO): Observable<any> {
    return this.http.post<any>(UserLicenses_summary, data);
  }
}
